import React, {
  useCallback, useEffect, useMemo, useRef, useState,
} from 'react';
import LogicaContext from './context';
import { childrenPropType } from '../../common/proptypes';
import { widgetModes } from '../../containers/services/SignKey/auth';
import api from '../../api/req';

function LogicaContextProvider({ children }) {
  const [logikaData, setLogicaData] = useState(null);
  const [widgetMode, setWidgetMode] = useState(null);
  const widgetModeRef = useRef();
  widgetModeRef.current = widgetMode;

  useEffect(
    () => {
      const savedValue = localStorage.getItem('logica_widget_type');
      if (!(savedValue in widgetModes)) {
        // default value
        setWidgetMode(widgetModes.ciat);
      } else {
        setWidgetMode(savedValue);
      }
      return () => localStorage.setItem('logica_widget_type', widgetModeRef.current);
    },
    [],
  );

  const [documentsOnValidation, setDocumentsOnValidation] = useState([]);
  const addDocumentToValidation = useCallback(
    ({ uid, isBS = false, title = '' }) => setDocumentsOnValidation(
      (o) => [...o.filter((i) => i.uid !== uid), { uid, isBS, title }],
    ),
    [],
  );

  const removeDocumentOnValidation = useCallback(
    (uid) => setDocumentsOnValidation(
      (o) => [...o.filter((i) => i.uid !== uid)],
    ),
    [],
  );

  const onLogikaLogin = useCallback(
    (data) => {
      setLogicaData(data);
      localStorage.setItem('logica_data', JSON.stringify(data));
    },
    [],
  );

  useEffect(
    () => {
      const d = localStorage.getItem('logica_data');
      if (d && !logikaData) {
        try {
          setLogicaData(JSON.parse(d));
        } catch {
          logikaData.removeItem('logica_data');
        }
      }
    },
    [logikaData],
  );

  useEffect(
    () => () => setLogicaData(null),
    [],
  );

  const onLogout = useCallback(
    () => {
      setLogicaData(null);
      localStorage.removeItem('logica_data');
    },
    [],
  );

  const isValidTicket = useCallback(
    async (ticket) => {
      const response = await api.post$('/api/auth/ticket_check/', () => null, {
        ticket,
      });

      return !!response.ok;
    },
    [],
  );

  const ctxValue = useMemo(
    () => ({
      data: logikaData,
      onLogin: onLogikaLogin,
      ticket: logikaData ? logikaData.ticket : null,
      onLogout,
      widgetMode,
      setWidgetMode,
      widgetURI: 'https://certs.ciat.net.ua/',
      isValidTicket,
      documentsOnValidation,
      addDocumentToValidation,
      removeDocumentOnValidation,
    }),
    [addDocumentToValidation, documentsOnValidation, isValidTicket, logikaData, onLogikaLogin,
      onLogout, removeDocumentOnValidation, widgetMode],
  );

  return (
    <LogicaContext.Provider value={ctxValue}>
      {children}
    </LogicaContext.Provider>
  );
}

LogicaContextProvider.propTypes = {
  children: childrenPropType.isRequired,
};

export default LogicaContextProvider;
